<template>
  <div id="latest_news_outer">
    <div id="latest_menu">
      <a v-for="(item, index) in tabList" :class="[tabIndex == index ? 'active' : '']"
         :href="menuPath(index)"
      >{{item}}</a>
    </div>

    <div id="latest_news_content" v-if="itemList != null">
      <div v-if="itemList.length > 0">
        <latest-news-item-card v-for="(item, index) in itemList" :href="itemSrc(item)" :item="item" :key="'latest_news_' + index" />
      </div>
      <div v-else style="font-size: 1.5rem;padding-top: 120px;text-align: center;">
        暂无内容
      </div>

    </div>

    <div style="padding-right: 30px;">
      <bottom-paginator
        v-bind:current="pageIndex"
        v-bind:total="totalPage"
        v-bind:paginator-type="1"
        v-on:itemClicked="paginatorClicked"
      />
    </div>

  </div>
</template>

<script>
import GlobalInstance from '../../js/shba'
import BottomPaginator from "../BottomPaginator";
import LatestNewsItemCard from "./LatestNewsItemCard";
export default {
  name: "LatestNewsList",
  components: {
    BottomPaginator,
    LatestNewsItemCard
  },
  data() {
    return {
      title: '最新动态',
      tabList:[
        '全部',
        '赛事',
        '培训'
      ],
      itemList: null,
      pageIndex: 1,
      size: 10,
      count: 0,
      isLoading: false,
    }
  },
  computed: {
    tabIndex() {
      let index = this.$route.params.index;
      return index != undefined ? index - 1 : 0;
    },
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    },

    menuId() {
      return GlobalInstance.methods.currentSubTabId(this.$route);
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    menuPath(index) {
      let item = this.currentMenuItem;
      let path = item.src + '/' + this.menuId + '/' + (index + 1);
      path += '#latest_menu'
      return path;
    },

    paginatorClicked(event) {
      let index = event.index;
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      if (this.isLoading) {
        return;
      }
      let pageIndex = this.pageIndex;
      let tag = this.tabList[this.tabIndex];
      let params = {
        pageIndex,
        size: this.size,
        type: 1,
        tag
      };
      this.isLoading = true;
      let _this = this;
      this.$store.state.http.ajax.vmActivities(params,function (data) {
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          _this.count = data.count;

          if (newList.length > 0) {
            _this.itemList = newList;
            return;
          }
        }

        _this.$toast('请求失败！');

      },function (data) {
        _this.isLoading = false;
        _this.$toast('请求失败，请重试！');
      });
    },
    itemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0302/0/' + item.id;
    },
  }
}
</script>

<style scoped>

  #latest_news_outer {
    width: 100%;
  }

  #latest_menu {
    flex-direction: row;
  }

  #latest_menu a {
    color: #333;
    font-size: 1.5rem;
    font-weight: bold;
    padding: 5px 0;
    display: inline-block;
    text-decoration: none;
  }

  #latest_menu a.active {
    color: #fc1a34;
    border-bottom: solid 3px #fc1a34;
    pointer-events: none;
  }

  #latest_menu a:hover {
    color: #fc1a34;
  }

  #latest_menu a:not(:first-child) {
    margin-left: 30px;
  }

  #latest_news_content {
    width: 100%;
    min-height: 300px;
  }

</style>



// WEBPACK FOOTER //
// src/components/news/LatestNewsList.vue